import './Footer.css';

function Footer() {
  return (
    <div id="Footer" className="FooterContainer">
        <div className="FooterText">
            © 2021 . Todos os direitos reservados <div className="inline red">Sofie</div>
        </div>
        <a href="https://play.google.com/store/apps/details?id=com.sofie.sofier&hl=pt_BR&utm_source=lp-sofie&utm_campaign=video&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1">
            <img width="163px" alt="Disponível no Google Play" src="https://play.google.com/intl/pt-BR/badges/static/images/badges/pt_badge_web_generic.png" />
        </a>
    </div>
  );
}

export default Footer;
